<template>
  <!-- eslint-disable -->
<div class="loader-container">
  <div class="medical-loader">
    <!-- Contenedor principal del loader -->
    <div class="loader-wrapper">
      <!-- Icono médico animado -->
      <div class="medical-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="heartbeat-path" d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z" :fill="prestador.admin.assets.colors.primary"/>
        </svg>
        <div class="pulse-ring"></div>
        <div class="pulse-ring pulse-ring-delay"></div>
      </div>
      
      <!-- Barra de progreso estilo Notion -->
      <div class="progress-container">
        <div class="progress-track">
          <div class="progress-fill" :style="{ background: `linear-gradient(90deg, ${prestador.admin.assets.colors.primary}, ${prestador.admin.assets.colors.secondary})` }">
            <div class="progress-shimmer"></div>
          </div>
        </div>
      </div>
      
      <!-- Texto de carga -->
      <div class="loading-text">
        <span class="loading-message">Cargando información médica</span>
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
      
      <!-- Indicadores de estado médico -->
      <div class="medical-indicators">
        <div class="indicator active">
          <div class="indicator-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" :fill="prestador.admin.assets.colors.primary"/>
            </svg>
          </div>
          <span class="indicator-text">Conectando</span>
        </div>
        
        <div class="indicator">
          <div class="indicator-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <span class="indicator-text">Verificando</span>
        </div>
        
        <div class="indicator">
          <div class="indicator-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z" fill="currentColor"/>
            </svg>
          </div>
          <span class="indicator-text">Cargando datos</span>
        </div>
      </div>
    </div>
    
    <!-- Loader SVG original (oculto pero mantenido para compatibilidad) -->
    <div class="original-loader" style="display: none;">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:none;display:block;" :width="width+'px'" :height="height+'px'" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <defs>
          <clipPath id="ldio-wddpnfk95h9-cp" x="0" y="0" width="100" height="100">
            <path d="M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z"></path>
          </clipPath>
        </defs>
        <path fill="none" stroke="#575757" stroke-width="2.7928" d="M82 63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z"></path>
        <g clip-path="url(#ldio-wddpnfk95h9-cp)">
          <g>
            <rect x="-100" y="0" width="25" height="100" :fill="prestador.admin.assets.colors.primary"></rect>
            <rect x="-75" y="0" width="25" height="100"  :fill="prestador.admin.assets.colors.secondary"></rect>
            <rect x="-50" y="0" width="25" height="100" :fill="prestador.admin.assets.colors.primary"></rect>
            <rect x="-25" y="0" width="25" height="100" :fill="prestador.admin.assets.colors.secondary"></rect>
            <rect x="0" y="0" width="25" height="100" :fill="prestador.admin.assets.colors.primary"></rect>
            <rect x="25" y="0" width="25" height="100" :fill="prestador.admin.assets.colors.secondary"></rect>
            <rect x="50" y="0" width="25" height="100" :fill="prestador.admin.assets.colors.primary"></rect>
            <rect x="75" y="0" width="25" height="100" :fill="prestador.admin.assets.colors.secondary"></rect>
            <animateTransform attributeName="transform" type="translate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0;100"></animateTransform>
          </g>
        </g>
      </svg>
    </div>
  </div>
</div>
</template>

<script>
 /* eslint-disable */
import {mapGetters} from 'vuex';


export default {
  name: 'Loader',
  props: {
      height: Number,
      width: Number,
     },

  data() {
    return {

    }
  },
  created(){
  

  },


  computed:{
    ...mapGetters(['prestador']),
  },



}
</script>


<style scoped>
/* Variables CSS para consistencia */
:root {
  --primary-color: #0ea5e9;
  --secondary-color: #10b981;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --background-primary: #fafbfc;
  --background-secondary: #ffffff;
  --border-color: #e2e8f0;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
}

/* Contenedor principal */
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(250, 251, 252, 0.95);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.medical-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: var(--background-secondary);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-color);
  max-width: 400px;
  width: 90%;
  margin: 20px;
}

.loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
}

/* Icono médico con animación */
.medical-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin-bottom: 8px;
}

.medical-icon svg {
  position: relative;
  z-index: 2;
  animation: heartbeat 2s ease-in-out infinite;
}

.heartbeat-path {
  filter: drop-shadow(0 2px 4px rgba(14, 165, 233, 0.3));
}

/* Anillos de pulso */
.pulse-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  opacity: 0;
  animation: pulse 2s ease-out infinite;
}

.pulse-ring-delay {
  animation-delay: 1s;
}

/* Barra de progreso estilo Notion */
.progress-container {
  width: 100%;
  margin: 16px 0;
}

.progress-track {
  width: 100%;
  height: 8px;
  background-color: #f1f5f9;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  width: 100%;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  animation: progressFill 2s ease-in-out infinite;
}

.progress-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 1.5s ease-in-out infinite;
}

/* Texto de carga */
.loading-text {
  text-align: center;
  margin: 8px 0;
}

.loading-message {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  display: block;
  margin-bottom: 8px;
}

.loading-dots {
  display: flex;
  justify-content: center;
  gap: 4px;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: var(--primary-color);
  border-radius: 50%;
  animation: dotBounce 1.4s ease-in-out infinite both;
}

.dot:nth-child(1) { animation-delay: -0.32s; }
.dot:nth-child(2) { animation-delay: -0.16s; }
.dot:nth-child(3) { animation-delay: 0s; }

/* Indicadores de estado médico */
.medical-indicators {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}

.indicator {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: var(--radius-md);
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  opacity: 0.5;
}

.indicator.active {
  opacity: 1;
  background-color: #eff6ff;
  border-color: var(--primary-color);
  transform: translateX(4px);
}

.indicator-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--background-secondary);
  color: var(--text-muted);
  transition: all 0.3s ease;
}

.indicator.active .indicator-icon {
  background-color: var(--primary-color);
  color: white;
  animation: iconPulse 2s ease-in-out infinite;
}

.indicator-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.indicator.active .indicator-text {
  color: var(--text-primary);
  font-weight: 600;
}

/* Animaciones */
@keyframes heartbeat {
  0%, 100% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(1.15);
  }
}

@keyframes pulse {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.2);
  }
}

@keyframes progressFill {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@keyframes dotBounce {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(14, 165, 233, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 8px rgba(14, 165, 233, 0);
  }
}

/* Animación secuencial de indicadores */
.indicator:nth-child(1) {
  animation: indicatorActivate 6s ease-in-out infinite;
  animation-delay: 0s;
}

.indicator:nth-child(2) {
  animation: indicatorActivate 6s ease-in-out infinite;
  animation-delay: 2s;
}

.indicator:nth-child(3) {
  animation: indicatorActivate 6s ease-in-out infinite;
  animation-delay: 4s;
}

@keyframes indicatorActivate {
  0%, 83.33% {
    opacity: 0.5;
    transform: translateX(0);
    background-color: #f8fafc;
    border-color: #e2e8f0;
  }
  16.67%, 33.33% {
    opacity: 1;
    transform: translateX(4px);
    background-color: #eff6ff;
    border-color: var(--primary-color);
  }
  50%, 100% {
    opacity: 0.5;
    transform: translateX(0);
    background-color: #f8fafc;
    border-color: #e2e8f0;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .medical-loader {
    padding: 32px 24px;
    margin: 16px;
  }
  
  .medical-icon {
    width: 64px;
    height: 64px;
  }
  
  .medical-icon svg {
    width: 40px;
    height: 40px;
  }
  
  .pulse-ring {
    width: 64px;
    height: 64px;
  }
  
  .loading-message {
    font-size: 1rem;
  }
  
  .medical-indicators {
    gap: 8px;
  }
  
  .indicator {
    padding: 6px 10px;
  }
  
  .indicator-text {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .loader-container {
    padding: 16px;
  }
  
  .medical-loader {
    padding: 24px 20px;
    margin: 12px;
  }
  
  .loader-wrapper {
    gap: 20px;
  }
  
  .medical-icon {
    width: 56px;
    height: 56px;
  }
  
  .medical-icon svg {
    width: 36px;
    height: 36px;
  }
  
  .pulse-ring {
    width: 56px;
    height: 56px;
  }
  
  .loading-message {
    font-size: 0.9rem;
  }
  
  .progress-track {
    height: 6px;
  }
}

/* Modo oscuro (opcional para futuras implementaciones) */
@media (prefers-color-scheme: dark) {
  :root {
    --text-primary: #f1f5f9;
    --text-secondary: #cbd5e1;
    --text-muted: #94a3b8;
    --background-primary: #0f172a;
    --background-secondary: #1e293b;
    --border-color: #334155;
  }
  
  .loader-container {
    background: rgba(15, 23, 42, 0.95);
  }
  
  .indicator {
    background-color: #1e293b;
    border-color: #334155;
  }
  
  .indicator.active {
    background-color: #1e3a8a;
  }
}

/* Animaciones suaves para usuarios que prefieren menos movimiento */
@media (prefers-reduced-motion: reduce) {
  .medical-icon svg,
  .pulse-ring,
  .progress-fill,
  .dot,
  .indicator {
    animation: none;
  }
  
  .progress-fill {
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  }
  
  .indicator.active {
    opacity: 1;
    transform: none;
  }
}
</style>

